/* Custom product info — core behaviour: gallery carousel, variant selection,
   quantity stepper, and the personalise-button URL fallback.

   Features register an init(root) function on the shared `window.CPI.inits`
   list; `boot()` runs every registered init once per section root. Additional
   feature files (e.g. cpi-modal.js) push their own init onto the same list. */
window.CPI = window.CPI || { inits: [] };
(function (CPI) {
  function initCarousel(root) {
    var viewport = root.querySelector('[data-cpi-viewport]');
    var track = root.querySelector('[data-cpi-track]');
    if (!viewport || !track) return;
    var prev = root.querySelector('[data-cpi-prev]');
    var next = root.querySelector('[data-cpi-next]');

    /* Seamless loop: clone the last slide onto the front of the track and the
       first onto the end, so "next" on the last image slides forward into the
       first (and "prev" on the first slides back into the last) instead of
       rewinding across every slide. Once the animation lands on a clone we
       snap — transition disabled — to the matching real slide. Clones carry
       data-cpi-clone so feature queries can exclude them.

       Slides switched off with the `hidden` attribute (the other colours' In
       Action shots) take no room in the track, so the loop runs over the
       visible slides only. root.cpiRefresh() rebuilds it when that set
       changes. */
    var count = 0;
    var pos = 1; // slot in the track incl. the leading clone; 1 = first real slide
    var sliding = false;
    var settleTimer = null;
    var headClone = null; // copy of the last slide, parked before the first
    var tailClone = null; // copy of the first slide, parked after the last

    function realSlides() {
      return Array.prototype.filter.call(track.children, function (s) {
        return !s.hasAttribute('data-cpi-clone') && !s.hidden;
      });
    }
    function cloneOf(slide) {
      var c = slide.cloneNode(true);
      c.setAttribute('data-cpi-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.cpiSource = slide;
      return c;
    }
    function setX(animate) {
      // Step by the slide's real border-box width, not the viewport's. The
      // track's -1.6rem margin + each slide's 1.6rem gutter make every slide
      // 1.6rem wider than the viewport; stepping by viewport width drifts
      // 1.6rem further off per slide (visible as a sliver of the previous one).
      var first = headClone || realSlides()[0];
      var w = first ? first.getBoundingClientRect().width : viewport.clientWidth;
      if (!animate) track.style.transition = 'none';
      track.style.transform = 'translate3d(' + (-pos * w) + 'px, 0px, 0px)';
      if (!animate) { void track.offsetWidth; track.style.transition = ''; }
    }
    function build() {
      var slides = realSlides();
      count = slides.length;
      var loop = count > 1;
      if (prev) prev.style.display = loop ? '' : 'none';
      if (next) next.style.display = loop ? '' : 'none';
      // Re-clone only when the slide being copied has changed: cpi-modal.js
      // mounts its live previews inside the clones of the burned slides too,
      // and a fresh copy would drop out of its reach.
      var wantHead = loop ? slides[count - 1] : null;
      var wantTail = loop ? slides[0] : null;
      if (headClone && headClone.cpiSource !== wantHead) { track.removeChild(headClone); headClone = null; }
      if (tailClone && tailClone.cpiSource !== wantTail) { track.removeChild(tailClone); tailClone = null; }
      if (wantHead && !headClone) headClone = cloneOf(wantHead);
      if (wantTail && !tailClone) tailClone = cloneOf(wantTail);
      if (headClone) track.insertBefore(headClone, track.firstChild);
      if (tailClone) track.appendChild(tailClone);
      clearTimeout(settleTimer);
      sliding = false;
      pos = loop ? Math.min(Math.max(pos, 1), count) : 0;
      setX(false);
    }
    /* After each slide: if we've landed on a clone, jump invisibly to its real
       counterpart so the next click keeps moving in the same direction. */
    function settle() {
      sliding = false;
      if (pos === 0) { pos = count; setX(false); }
      else if (pos === count + 1) { pos = 1; setX(false); }
    }
    function step(dir) {
      if (sliding || count <= 1) return;
      sliding = true;
      pos += dir;
      setX(true);
      // Fallback in case transitionend never fires (e.g. hidden tab).
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 500);
    }
    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      clearTimeout(settleTimer);
      settle();
    });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    window.addEventListener('resize', function () { setX(false); });
    build();
    root.cpiRefresh = build;

    /* Jump to a real slide (0-based, clones and hidden slides excluded) — used
       by the inline initials box to bring the personalised image into view
       while typing, and by the colour pills to show the new colour. */
    root.cpiGoTo = function (index) {
      if (count <= 1 || index < 0 || index >= count) return;
      var target = index + 1; // slot offset for the leading clone
      if (target === pos || sliding) return;
      sliding = true;
      pos = target;
      setX(true);
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 500);
    };
  }

  function initVariants(root) {
    var dataEl = root.querySelector('[data-cpi-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-cpi-id]');
    var atc = root.querySelector('[data-cpi-atc]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    var selected = {};

    function resolve() {
      // Options without a pill group (e.g. the hidden Initials dimension, owned
      // by the inline box / modal) are held at the current variant's value; the
      // pills drive the rest. Falls back to any match if the current variant is
      // unknown.
      var cur = null;
      if (idInput) {
        cur = variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || null;
      }
      function firstMatch(holdCur) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) {
            if (selected[i] != null) return o === selected[i];
            return holdCur && cur ? o === cur.options[i] : true;
          });
        });
      }
      var chosen = firstMatch(true) || firstMatch(false);
      if (!chosen) return;
      if (idInput) idInput.value = chosen.id;
      if (atc) {
        if (chosen.available) { atc.disabled = false; atc.textContent = 'Add to cart'; }
        else { atc.disabled = true; atc.textContent = 'Sold out'; }
      }
    }

    /* Dependent options: only show a pill if some variant pairs it with the
       selections of the EARLIER option groups — e.g. the joggers' Size run
       follows the chosen Fit (Women's 6–18, Men's XS–XXL, Kids ages). When the
       active value drops out (fit changed), fall to the first valid one.
       Products whose variants span every combination are left untouched. */
    function refreshPills() {
      groups.forEach(function (group) {
        var gi = parseInt(group.dataset.optionIndex, 10);
        var pills = Array.prototype.slice.call(group.querySelectorAll('.cpi__pill'));
        var visible = [];
        pills.forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          var ok = variants.some(function (v) {
            if (v.options[gi] !== val) return false;
            for (var j = 0; j < gi; j++) {
              if (selected[j] != null && v.options[j] !== selected[j]) return false;
            }
            return true;
          });
          btn.style.display = ok ? '' : 'none';
          if (ok) visible.push(btn);
        });
        var active = group.querySelector('.cpi__pill.is-active');
        if ((!active || active.style.display === 'none') && visible.length) {
          pills.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          visible[0].classList.add('is-active');
          visible[0].setAttribute('aria-pressed', 'true');
          selected[gi] = visible[0].getAttribute('data-value');
        }
      });
    }

    groups.forEach(function (group) {
      var i = parseInt(group.dataset.optionIndex, 10);
      var active = group.querySelector('.is-active');
      selected[i] = active ? active.getAttribute('data-value') : null;
      group.querySelectorAll('.cpi__pill').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.cpi__pill').forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          selected[i] = btn.getAttribute('data-value');
          refreshPills();
          resolve();
        });
      });
    });
    refreshPills();
    resolve();
  }

  /* Property-backed sizing pills (Fit / Size / Leg Length — joggers). These
     rows are NOT variant options (the option slots carry the personalisation
     toggles): each choice is written to a hidden properties[…] input so it
     rides on the cart line. The Size and Leg Length rows show only the
     selected fit's run (pills carry data-fit); on a fit change each falls to
     that fit's default (Regular leg) or else its first value. */
  function initSizing(root) {
    var wrap = root.querySelector('[data-cpi-sizing]');
    if (!wrap) return;
    var props = {};
    Array.prototype.slice.call(wrap.querySelectorAll('[data-cpi-sizing-prop]')).forEach(function (input) {
      props[input.getAttribute('data-cpi-sizing-prop')] = input;
    });
    function setProp(name, value) { if (props[name]) props[name].value = value; }
    function selectPill(row, btn) {
      row.querySelectorAll('.cpi__pill').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      setProp(row.getAttribute('data-cpi-sizing-row'), btn.getAttribute('data-value'));
    }
    function refreshSizes() {
      var fitRow = wrap.querySelector('[data-cpi-sizing-row="Fit"]');
      if (!fitRow) return;
      var fitActive = fitRow.querySelector('.cpi__pill.is-active');
      var fit = fitActive ? fitActive.getAttribute('data-value') : '';
      wrap.querySelectorAll('[data-cpi-sizing-row]').forEach(function (row) {
        if (!row.querySelector('.cpi__pill[data-fit]')) return;
        var firstVisible = null;
        var preferred = null;
        row.querySelectorAll('.cpi__pill').forEach(function (b) {
          var ok = b.getAttribute('data-fit') === fit;
          b.style.display = ok ? '' : 'none';
          if (ok && !firstVisible) firstVisible = b;
          if (ok && !preferred && b.hasAttribute('data-cpi-default')) preferred = b;
        });
        var active = row.querySelector('.cpi__pill.is-active');
        if ((!active || active.style.display === 'none') && firstVisible) {
          selectPill(row, preferred || firstVisible);
        }
      });
    }
    Array.prototype.slice.call(wrap.querySelectorAll('[data-cpi-sizing-row]')).forEach(function (row) {
      row.querySelectorAll('.cpi__pill').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectPill(row, btn);
          if (row.getAttribute('data-cpi-sizing-row') === 'Fit') refreshSizes();
        });
      });
      // Seed the hidden property from the server-rendered default selection.
      var active = row.querySelector('.cpi__pill.is-active');
      if (active) setProp(row.getAttribute('data-cpi-sizing-row'), active.getAttribute('data-value'));
    });
    refreshSizes();
  }

  /* Colour pills — a design the captain offered in several colours
     (custom.kit_colours; see cpi-colour-options.liquid). Colour is not a
     variant option: the pick rides as a line-item property, and the page is
     redrawn in that colour — the front/back photos, the garment under every
     live preview SVG, the colour's own product photos, and the In Action
     shots. */
  function initColours(root) {
    var wrap = root.querySelector('[data-cpi-colours]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-cpi-colour-prop]');
    var pills = Array.prototype.slice.call(wrap.querySelectorAll('.cpi__pill'));

    function hrefOf(img) {
      return img.getAttribute('href') || img.getAttribute('xlink:href') || '';
    }
    function setHref(img, url) {
      img.setAttribute('href', url);
      if (img.hasAttribute('xlink:href')) img.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', url);
    }
    // cpi-modal.js moves the modal to <body> once it boots.
    function modalEl() {
      return root.querySelector('[data-cpi-modal]') ||
        (root.id ? document.querySelector('[data-cpi-modal][data-cpi-owner="' + root.id + '"]') : null);
    }
    // Every image inside a preview SVG for this product: the gallery's (loop
    // clones and the live copies cpi-modal.js mounts included), the templates
    // those copies are made from, and the modal's.
    function previewImages() {
      var out = Array.prototype.slice.call(root.querySelectorAll('svg image'));
      Array.prototype.slice.call(root.querySelectorAll('template')).forEach(function (tpl) {
        if (tpl.content) out = out.concat(Array.prototype.slice.call(tpl.content.querySelectorAll('svg image')));
      });
      var modal = modalEl();
      if (modal && !root.contains(modal)) out = out.concat(Array.prototype.slice.call(modal.querySelectorAll('svg image')));
      return out;
    }
    // The garment photo a preview side draws now: the first <image> of that
    // side's SVG. Read off the page rather than the colour list, because the
    // product's own preview can point at a different copy of the same photo.
    function drawnGarment(side) {
      var img = root.querySelector('[data-cpi-preview="' + side + '"] svg image, [data-cpi-stage="' + side + '"] svg image');
      if (!img) {
        var tpl = root.querySelector('template[data-cpi-live-template="' + side + '"]');
        img = tpl && tpl.content ? tpl.content.querySelector('svg image') : null;
      }
      return img ? hrefOf(img) : '';
    }
    var drawn = { front: drawnGarment('front'), back: drawnGarment('back') };
    if (drawn.back === drawn.front) drawn.back = ''; // a back view that fell back to the front SVG

    function select(btn) {
      var name = btn.getAttribute('data-value');
      pills.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (input) input.value = name;

      // Photo galleries: the finished design in this colour.
      var photo = { front: btn.getAttribute('data-front'), back: btn.getAttribute('data-back') };
      Array.prototype.slice.call(root.querySelectorAll('.cpi__slide[data-cpi-burned] .cpi__photo')).forEach(function (img) {
        var url = photo[img.closest('[data-cpi-burned]').getAttribute('data-cpi-burned')];
        if (url) img.src = url;
      });

      // Live previews: swap the garment under the logo and marks, which leaves
      // the elements other features hold (initials, placements) in place.
      var art = { front: btn.getAttribute('data-art-front'), back: btn.getAttribute('data-art-back') };
      previewImages().forEach(function (img) {
        var href = hrefOf(img);
        if (!href) return;
        if (href === drawn.front && art.front) setHref(img, art.front);
        else if (href === drawn.back && art.back) setHref(img, art.back);
      });
      if (art.front) drawn.front = art.front;
      if (art.back) drawn.back = art.back;

      // This colour's product photos (gallery) and In Action shots (gallery and
      // accordion) only.
      Array.prototype.slice.call(root.querySelectorAll('[data-cpi-shot-colour]:not([data-cpi-clone])')).forEach(function (el) {
        el.hidden = el.getAttribute('data-cpi-shot-colour') !== name;
      });
      Array.prototype.slice.call(root.querySelectorAll('[data-cpi-inaction]')).forEach(function (grid) {
        var shown = grid.querySelectorAll('.cpi__inaction-item:not([hidden])').length;
        grid.className = grid.className.replace(/\bcpi__inaction--cols-\d+\b/, 'cpi__inaction--cols-' + Math.min(3, Math.max(1, shown)));
      });

      if (typeof root.cpiRefresh === 'function') root.cpiRefresh();
      if (typeof root.cpiGoTo === 'function') root.cpiGoTo(0); // show the front in the new colour
    }

    pills.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!btn.classList.contains('is-active')) select(btn);
      });
    });
  }

  function initQty(root) {
    var val = root.querySelector('[data-cpi-qtyval]');
    var input = root.querySelector('[data-cpi-qty]');
    if (!val || !input) return;
    root.querySelectorAll('[data-cpi-qtystep]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = parseInt(input.value || '1', 10);
        q += (btn.getAttribute('data-cpi-qtystep') === 'inc' ? 1 : -1);
        if (q < 1) q = 1;
        input.value = q;
        val.textContent = q;
      });
    });
  }

  /* Inline "Add Your Initials or Name" box (hoodies / initials-only kits).
     Replaces the personalise modal. One button drives an Add → Edit cycle:
     "Add Initials" reveals the field (editing, +£2 variant); "Add" commits the
     typed value and LOCKS the field; "Edit" unlocks it again. Committing an
     empty field removes the initials and reverts to the base variant. The
     value rides along as a line-item property. */
  function initInlineInitials(root) {
    var box = root.querySelector('[data-cpi-initials-inline]');
    if (!box) return;
    var idInput = root.querySelector('[data-cpi-id]');
    var atc = root.querySelector('[data-cpi-atc]');
    var priceEl = root.querySelector('[data-cpi-price]');
    var propsHost = root.querySelector('[data-cpi-props]');
    var moneyFormat = root.getAttribute('data-cpi-money-format') || '{{amount}}';

    var variantData = [];
    var optionNames = [];
    var vEl = root.querySelector('[data-cpi-variants]');
    var nEl = root.querySelector('[data-cpi-option-names]');
    try { if (vEl) variantData = JSON.parse(vEl.textContent); } catch (e) {}
    try {
      if (nEl) optionNames = JSON.parse(nEl.textContent).map(function (o) {
        return o && typeof o === 'object' ? o.name : o;
      });
    } catch (e) {}

    var optName = box.getAttribute('data-opt-name');
    var valOn = box.getAttribute('data-val-on');
    var valOff = box.getAttribute('data-val-off');
    var propName = box.getAttribute('data-prop-name') || 'Initials';
    var optIdx = optionNames.indexOf(optName);

    var addBtn = box.querySelector('[data-cpi-initials-add]');
    var addLabel = box.querySelector('[data-cpi-initials-label]');
    var input = box.querySelector('[data-cpi-initials-input]');
    // Remember the Liquid-rendered price ("From £x – £y") so we can restore it
    // when the buyer opts back out of initials.
    var origPrice = priceEl ? priceEl.innerHTML : null;

    // The embroidery mark(s) baked into the live gallery SVG (front, and back if
    // the placement sits there). Updating their text shows the typed initials on
    // the garment at the exact spot the real embroidery goes.
    var marks = Array.prototype.slice.call(root.querySelectorAll('[data-cpi-preview] [data-cpi-place="initials"]'));
    var initialsDefault = (marks[0] && marks[0].textContent) || 'XYZ';

    // Which real gallery slide (0-based, carousel clones and hidden slides
    // excluded, as cpiGoTo counts them) an element sits on — so typing can
    // pull the initials-carrying image into view.
    function realSlideIndex(el) {
      var slide = el && el.closest ? el.closest('.cpi__slide') : null;
      if (!slide || slide.hasAttribute('data-cpi-clone')) return -1;
      var slides = Array.prototype.slice.call(root.querySelectorAll('.cpi__slide:not([data-cpi-clone]):not([hidden])'));
      return slides.indexOf(slide);
    }

    // Bags have no live preview SVG: their gallery shows rasterised hero PNGs
    // with a placeholder "XYZ" initials mark burned into the image. Overlay a
    // live mark on the photo instead — its solid backing (colour-matched to
    // the surrounding fabric) hides the burned placeholder, and the typed
    // initials render on top at the same spot.
    //
    // A captain can put initials on BOTH bag faces (side and end). Each face
    // carrying them ships its own anchor, so build one overlay per face: the
    // buyer types their name once and sees it on every face it is printed on.
    var photoMarks = [];   // one live overlay per configured bag face
    var photoFaces = [];   // 'side' / 'end' for each of those overlays
    var photoSlide = -1;   // first slide carrying an overlay, set below
    if (!marks.length && box.getAttribute('data-placement') === 'bag') {
      photoConfigs().forEach(function (raw) {
        var made = buildPhotoMark(raw);
        if (!made) return;
        photoMarks.push(made.el);
        if (photoFaces.indexOf(made.face) < 0) photoFaces.push(made.face);
        if (photoSlide < 0 && made.slide >= 0) photoSlide = made.slide;
      });
    }
    // The captain's anchors: the `photos` list (one entry per face), falling
    // back to the single legacy `photo` block, then to the built-in defaults.
    function photoConfigs() {
      var listEl = box.querySelector('[data-cpi-initials-photos]');
      var oneEl = box.querySelector('[data-cpi-initials-photo]');
      try {
        if (listEl) {
          var list = JSON.parse(listEl.textContent);
          if (list && list.length) return list;
        } else if (oneEl) {
          return [JSON.parse(oneEl.textContent) || {}];
        }
      } catch (e) {}
      return [{}];
    }
    // The hero photo for one face. The gallery tags the side hero
    // data-cpi-burned="front" and the end hero "back"; fall back to slide
    // order for products whose images carry no such tag.
    function mediaForFace(face) {
      var slide = root.querySelector(
        '.cpi__slide[data-cpi-burned="' + (face === 'end' ? 'back' : 'front') + '"]:not([data-cpi-clone])'
      );
      var tagged = slide && slide.querySelector('.cpi__media--photo');
      if (tagged) return tagged;
      // Skip the carousel's loop clones — the overlay belongs on the real slides.
      var medias = root.querySelectorAll('.cpi__slide:not([data-cpi-clone]) .cpi__media--photo');
      return (face === 'end' ? medias[1] : medias[0]) || null;
    }
    function buildPhotoMark(raw) {
      // Defaults match the sports bag (600×400 face on a 600×780 hero canvas,
      // mark at 51% / 36% of the face, 18px nominal initials). Products created
      // after the `photo` block was added to kit_personalisation carry exact
      // values (including the holdall's geometry and the captain's colour).
      // `clean: true` (current products) = the hero has NO burned-in placeholder,
      // so the typed initials render straight on the photo; legacy products get
      // the fabric-matched backing patch that hides their burned "XYZ" mark.
      var cfg = { face: 'side', x: 0.51, y: 0.4282, fontFrac: 0.0402, color: '', clean: false };
      if (raw) for (var k in cfg) if (raw[k] != null && raw[k] !== '') cfg[k] = raw[k];
      var media = mediaForFace(cfg.face);
      var img = media && media.querySelector('img');
      if (!img) return null;
      var slide = realSlideIndex(media);
      var made = { el: null, face: cfg.face, slide: slide };

      var el = document.createElement('span');
      // Clean heroes render the mark as bare text (customizer-identical, via
      // the --clean modifier); legacy heroes keep the backing patch that hides
      // their burned-in placeholder.
      el.className = 'cpi__photo-initials is-hidden' + (cfg.clean ? ' cpi__photo-initials--clean' : '');
      el.style.color = cfg.color || '#ffffff';
      if (!cfg.clean) el.style.background = '#161616';
      media.appendChild(el);
      made.el = el;

      // Map the burned mark's natural-image anchor through the photo's actual
      // rendered rect (the hero is contained/centred in the wash box, so the
      // element box no longer matches the media box) so the overlay tracks it
      // at any viewport size.
      function position() {
        var iw = img.naturalWidth, ih = img.naturalHeight;
        if (!iw || !ih) return;
        var mediaRect = media.getBoundingClientRect();
        var imgRect = img.getBoundingClientRect();
        if (!imgRect.width || !imgRect.height) return;
        var fit = (window.getComputedStyle(img).objectFit || 'fill');
        var scale = fit === 'cover'
          ? Math.max(imgRect.width / iw, imgRect.height / ih)
          : Math.min(imgRect.width / iw, imgRect.height / ih);
        var offX = imgRect.left - mediaRect.left + (imgRect.width - iw * scale) / 2;
        var offY = imgRect.top - mediaRect.top + (imgRect.height - ih * scale) / 2;
        el.style.left = (offX + cfg.x * iw * scale) + 'px';
        el.style.top = (offY + cfg.y * ih * scale) + 'px';
        el.style.fontSize = (cfg.fontFrac * iw * scale) + 'px';
      }
      if (img.complete) position(); else img.addEventListener('load', position);
      window.addEventListener('resize', position);

      // Legacy burned-placeholder heroes only: colour-match the backing to the
      // bag fabric and, for products created before the print colour rode along
      // in the metafield, lift it from the burned mark itself. Needs a CORS
      // re-fetch of the hero; if the canvas is tainted the near-black fallback
      // set above stays. Clean heroes skip all of this.
      if (cfg.clean) return made;
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var cv = document.createElement('canvas');
          cv.width = probe.naturalWidth;
          cv.height = probe.naturalHeight;
          var ctx = cv.getContext('2d');
          ctx.drawImage(probe, 0, 0);
          function at(fx, fy) {
            return ctx.getImageData(Math.round(fx * cv.width), Math.round(fy * cv.height), 1, 1).data;
          }
          // Fabric: average of four points just outside the burned mark.
          var pts = [[-0.1, 0], [0.1, 0], [0, -0.035], [0, 0.035]];
          var r = 0, g = 0, b = 0;
          pts.forEach(function (p) {
            var d = at(cfg.x + p[0], cfg.y + p[1]);
            r += d[0]; g += d[1]; b += d[2];
          });
          r /= pts.length; g /= pts.length; b /= pts.length;
          el.style.background = 'rgb(' + Math.round(r) + ',' + Math.round(g) + ',' + Math.round(b) + ')';
          if (!cfg.color) {
            // Print colour: the pixel across the mark differing most from the
            // fabric (the burned glyphs are the only differing pixels there).
            var best = null, bestDist = 90; // min distance so plain fabric never wins
            for (var i = -12; i <= 12; i++) {
              var d2 = at(cfg.x + i * 0.004, cfg.y);
              var dist = Math.abs(d2[0] - r) + Math.abs(d2[1] - g) + Math.abs(d2[2] - b);
              if (dist > bestDist) { bestDist = dist; best = d2; }
            }
            if (best) el.style.color = 'rgb(' + best[0] + ',' + best[1] + ',' + best[2] + ')';
          }
        } catch (e) { /* cross-origin canvas blocked — keep fallbacks */ }
      };
      probe.src = img.currentSrc || img.src;
      return made;
    }
    // The slide the initials land on: the bag photo overlay's slide, or the
    // first live-preview slide carrying an embroidery mark (hoodie front).
    var initialsSlide = photoSlide;
    if (initialsSlide < 0) {
      for (var mi = 0; mi < marks.length; mi++) {
        var msi = realSlideIndex(marks[mi]);
        if (msi >= 0) { initialsSlide = msi; break; }
      }
    }
    // Bring that slide into view (opting in / typing) so the buyer watches
    // their initials appear on the garment, not an unrelated lifestyle shot.
    function showInitialsSlide() {
      if (initialsSlide >= 0 && typeof root.cpiGoTo === 'function') root.cpiGoTo(initialsSlide);
    }

    // Cap input by LETTERS (whitespace excluded) — the input's maxlength is a
    // loose backstop, so a space in "JOHN SMITH" doesn't consume a letter slot.
    var maxLetters = parseInt(box.getAttribute('data-max-letters') || '9', 10) || 9;
    function clampLetters(v) {
      var out = '';
      var letters = 0;
      for (var i = 0; i < v.length; i++) {
        if (/\s/.test(v[i])) { out += v[i]; continue; }
        if (letters >= maxLetters) break;
        out += v[i];
        letters++;
      }
      return out;
    }

    function previewText() {
      var v = input ? (input.value || '').trim().toUpperCase() : '';
      return v || initialsDefault; // fall back to the placeholder mark before typing
    }
    // Paint the mark's text, wrapping onto a new line every data-init-linemax
    // letters so a long name stays clear of the centre logo. Lines are stacked
    // and vertically centred on the mark's y; the parent text-anchor keeps them
    // aligned (right-anchored for the chest placement).
    function fillMark(el, text) {
      var max = parseInt(el.getAttribute('data-init-linemax') || '0', 10);
      if (!max || text.length <= max) { el.textContent = text; return; }
      var lineH = parseFloat(el.getAttribute('data-init-lineh') || '18');
      var x = el.getAttribute('x');
      // First line holds `max` letters; everything after drops to the next line.
      var lines = [text.slice(0, max), text.slice(max)];
      while (el.firstChild) el.removeChild(el.firstChild);
      var start = -((lines.length - 1) * lineH) / 2;
      lines.forEach(function (line, idx) {
        var ts = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        if (x != null) ts.setAttribute('x', x);
        ts.setAttribute('dy', String(idx === 0 ? start : lineH));
        ts.textContent = line;
        el.appendChild(ts);
      });
    }
    function renderMarks(on) {
      var t = previewText();
      marks.forEach(function (el) {
        fillMark(el, t);
        el.classList.toggle('is-hidden', !on); // hidden until the buyer opts in
      });
      // Every bag face carrying initials shows the same typed name.
      photoMarks.forEach(function (el) {
        el.textContent = t;
        el.classList.toggle('is-hidden', !on);
      });
    }

    // PDP layout guard: keep chest initials clear of the centre logo even on
    // products whose preview SVG predates the right-anchored/wrapping layout.
    // Locate the logo (a sub-garment <image>, narrower than the 600-wide base
    // art) and, for any initials mark sitting at/over it, right-anchor just to
    // the left of the logo and turn on wrapping. Runs client-side so it applies
    // to every hoodie PDP regardless of when the product was generated.
    (function () {
      // Enforce 4 letters per line and a small embroidery font on every initials
      // mark (override whatever the product's SVG was baked with) so wrapped
      // initials stay on the chest panel and don't overflow toward the sleeve.
      marks.forEach(function (el) {
        el.setAttribute('data-init-linemax', '5');
        el.setAttribute('data-init-lineh', '14');
        el.setAttribute('font-size', '11');
        el.style.letterSpacing = '0.08em';
      });
      var placement = box.getAttribute('data-placement');
      if (placement === 'sleeve') return; // sleeve never overlaps the logo
      var front = root.querySelector('[data-cpi-preview="front"]') || root.querySelector('[data-cpi-preview]');
      if (!front) return;
      var CHEST_X = 230; // fixed centre X for chest initials (user units)
      // Find the logo (a sub-garment <image>, narrower than the 600-wide base art)
      // so we can sit the initials in line with it vertically.
      var imgs = front.querySelectorAll('image');
      var logoEl = null, logoLeft = null;
      for (var i = 0; i < imgs.length; i++) {
        var w = parseFloat(imgs[i].getAttribute('width') || '0');
        var lx = parseFloat(imgs[i].getAttribute('x'));
        if (w && w < 600 && !isNaN(lx) && (logoLeft == null || lx < logoLeft)) { logoLeft = lx; logoEl = imgs[i]; }
      }
      var logoCenterY = null;
      if (logoEl) {
        var lt = parseFloat(logoEl.getAttribute('y'));
        var lh = parseFloat(logoEl.getAttribute('height'));
        if (!isNaN(lt) && !isNaN(lh)) logoCenterY = Math.round(lt + lh / 2);
      }
      // Centre chest initials at the fixed gap point (so they expand
      // symmetrically), in line with the logo.
      marks.forEach(function (el) {
        var mx = parseFloat(el.getAttribute('x'));
        // Chest when flagged as such, or (older products without the flag) any
        // front mark that isn't the far-left sleeve position (~165).
        var isChest = placement === 'chest' || (!isNaN(mx) && mx > 170);
        if (!isChest) return;
        el.setAttribute('x', CHEST_X);
        el.setAttribute('text-anchor', 'middle');
        if (logoCenterY != null) el.setAttribute('y', logoCenterY);
      });
    })();

    // Print spec (embroidery dimensions by letter count + location), so each order
    // carries the accurate fulfilment size for the seller.
    var placement = box.getAttribute('data-placement') || '';
    var printSpec = null;
    var pEl = box.querySelector('[data-cpi-initials-print]');
    try { if (pEl) printSpec = JSON.parse(pEl.textContent); } catch (e) {}
    // Count letters (ignoring whitespace), clamped to the spec's range.
    function letterCount(name) { return (name || '').replace(/\s+/g, '').length; }
    function sizeForLetters(n) {
      if (!printSpec || !printSpec.sizes || !printSpec.sizes.length) return null;
      var max = printSpec.maxLetters || printSpec.sizes.length;
      var k = Math.max(1, Math.min(max, n));
      for (var i = 0; i < printSpec.sizes.length; i++) {
        if (printSpec.sizes[i].letters === k) return printSpec.sizes[i];
      }
      return null;
    }
    // Where the initials are printed, named for the seller. A bag can carry
    // them on BOTH faces, so every configured face is listed; garments (and
    // bags predating the per-face anchors) fall back to the single placement.
    function printPositions() {
      var locs = printSpec && printSpec.locations;
      if (!locs) return [];
      var out = [];
      photoFaces.forEach(function (f) { if (locs[f]) out.push(locs[f]); });
      if (!out.length && placement && locs[placement]) out.push(locs[placement]);
      return out;
    }
    // Seller-facing name for a bag face, matching the supplier form's columns.
    var FACE_LABEL = { side: 'Side of Bag', end: 'End of Bag' };
    // With initials on more than one face, record the typed value against EACH
    // of them (seller-only, underscore-prefixed) so the order line states the
    // name is printed on the side AND the end — not just that initials were
    // bought. One face needs no such split: `_Embroidery position` says where.
    var faceProps = photoFaces.length > 1
      ? photoFaces.map(function (f) { return '_Initials ' + (FACE_LABEL[f] || f); })
      : [];

    function formatMoney(cents) {
      var v = cents / 100;
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, v.toFixed(2))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(v)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, v.toFixed(2).replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(v)));
    }

    // The variant matching `want` for the initials option, with every OTHER
    // option held at the currently-selected variant's value.
    function variantFor(initialsOn) {
      if (optIdx < 0 || !variantData.length) return null;
      var want = initialsOn ? valOn : valOff;
      var cur = variantData.filter(function (v) {
        return idInput && String(v.id) === String(idInput.value);
      })[0] || variantData[0];
      return variantData.filter(function (v) {
        var opts = v.options || [];
        if (opts[optIdx] !== want) return false;
        return opts.every(function (o, i) { return i === optIdx ? true : (!cur || o === cur.options[i]); });
      })[0];
    }

    // Point the cart form at the matching variant and reflect its price/availability.
    // `on` → "With initials" (+£2); off → base. The price falls back to the
    // original Liquid range when off so the default PDP shows "From £x – £y".
    function apply(on) {
      var v = variantFor(on);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (atc) {
        if (v.available === false) { atc.disabled = true; atc.textContent = 'Sold out'; }
        else { atc.disabled = false; atc.textContent = 'Add to cart'; }
      }
      if (priceEl) {
        if (on && typeof v.price === 'number') priceEl.textContent = formatMoney(v.price);
        else if (origPrice != null) priceEl.innerHTML = origPrice;
      }
    }

    // Add/update/remove a line-item property by name (empty value removes it).
    // Each is tracked by a data-cpi-prop tag so it can be cleared independently.
    function setProp(name, value) {
      if (!propsHost) return;
      var inputs = propsHost.querySelectorAll('input[data-cpi-prop]');
      var existing = null;
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].getAttribute('data-cpi-prop') === name) { existing = inputs[i]; break; }
      }
      if (value) {
        if (!existing) {
          existing = document.createElement('input');
          existing.type = 'hidden';
          existing.setAttribute('data-cpi-prop', name);
          existing.name = 'properties[' + name + ']';
          propsHost.appendChild(existing);
        }
        existing.value = value;
      } else if (existing) {
        existing.parentNode.removeChild(existing);
      }
    }

    // Mirror the current choice into cart line-item properties: the visible
    // initials text plus seller-only (underscore-prefixed) fulfilment details —
    // print dimensions for the typed letter count, position and method.
    function syncProps() {
      var name = (expanded && input) ? (input.value || '').trim() : '';
      setProp(propName, name);
      // The same name goes on every face it is printed on (empty clears them).
      faceProps.forEach(function (key) { setProp(key, name); });
      var n = letterCount(name);
      if (expanded && printSpec && n > 0) {
        var sz = sizeForLetters(n);
        setProp('_Print size', sz ? (sz.length + ' long x ' + sz.height + ' high') : '');
        setProp('_Print method', printSpec.method || '');
        setProp('_Embroidery position', printPositions().join(' + '));
      } else {
        setProp('_Print size', '');
        setProp('_Print method', '');
        setProp('_Embroidery position', '');
      }
    }

    // One-button Add → Edit cycle:
    //   'none'    → no initials (base variant), field hidden, button "Add Initials"
    //   'editing' → field editable (+£2 variant), button "Add" commits
    //   'set'     → field LOCKED (read-only), button "Edit" unlocks
    // Committing an empty field falls back to 'none' (initials removed).
    var state = 'none';
    var expanded = false; // state !== 'none' — read by syncProps
    function render() {
      expanded = state !== 'none';
      if (addBtn) {
        addBtn.classList.toggle('is-active', state === 'set');
        addBtn.setAttribute('aria-pressed', expanded ? 'true' : 'false');
      }
      if (addLabel) {
        addLabel.textContent = state === 'none' ? 'Add Initials' : state === 'editing' ? 'Add' : 'Edit';
      }
      if (input) {
        input.hidden = !expanded;
        input.readOnly = state === 'set';   // committed value shows fixed, not editable
        input.classList.toggle('is-locked', state === 'set');
      }
      apply(expanded);                      // opting in switches to the +£2 variant
      syncProps();
      renderMarks(expanded);                // show/hide the embroidery on the garment
      if (expanded) showInitialsSlide();    // and bring that image into view
      if (state === 'editing' && input) { try { input.focus(); } catch (e) {} }
    }
    function commit() {
      var v = input ? input.value.trim() : '';
      state = v ? 'set' : 'none';           // empty commit = initials removed
      render();
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (state === 'editing') commit();
        else { state = 'editing'; render(); } // "Add Initials" or "Edit" both open the field
      });
    }
    if (input) {
      input.addEventListener('input', function () {
        var clamped = clampLetters(input.value);
        if (clamped !== input.value) input.value = clamped;
        syncProps();
        renderMarks(true);                  // live-update the garment as they type
        showInitialsSlide();                // typing switches to the initials image
      });
      // Enter commits the value — it must never submit the product form.
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (state === 'editing') commit();
        }
      });
    }

    render(); // default: no initials → base variant, original price range
  }

  /* AJAX add-to-cart: the section renders a plain Liquid product form, so a
     native submit POSTs to /cart/add and Shopify redirects to the cart page.
     Intercept it and hand the response to the theme's cart drawer or cart
     notification instead. Falls through to the native submit (cart page)
     when neither cart element is on the page (cart type "page"). */
  function initAtc(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!cart || typeof cart.renderContents !== 'function') return; // native submit

      e.preventDefault();
      var btn = form.querySelector('[data-cpi-atc]');
      if (btn && btn.disabled) return;

      var errorEl = form.querySelector('[data-cpi-atc-error]');
      if (!errorEl && btn) {
        errorEl = document.createElement('p');
        errorEl.className = 'cpi__atc-error';
        errorEl.setAttribute('data-cpi-atc-error', '');
        errorEl.setAttribute('role', 'alert');
        errorEl.hidden = true;
        btn.insertAdjacentElement('afterend', errorEl);
      }
      if (errorEl) errorEl.hidden = true;

      var body = new FormData(form);
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            if (errorEl) {
              errorEl.textContent = response.description || response.message || 'Unable to add to cart.';
              errorEl.hidden = false;
            }
            return;
          }
          // PUB_SUB_EVENTS is a top-level const — not on window; check via typeof.
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: body.get('id'),
              cartData: response
            }).then(function (results) {
              // When the checkout popup opened, keep the drawer/notification
              // closed — sections still update so the cart icon count is fresh.
              var popupOpened = Array.isArray(results) && results.some(function (result) {
                return result && result.checkoutPopupOpened;
              });
              cart.renderContents(response, popupOpened);
            });
            return;
          }
          cart.renderContents(response);
        })
        .catch(function (err) {
          if (window.console) console.error(err);
          if (errorEl) {
            errorEl.textContent = 'Unable to add to cart. Please try again.';
            errorEl.hidden = false;
          }
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    });
  }

  function initPersonalise(root) {
    // If the modal exists, cpi-modal.js owns the click. Only fall back to a URL/event otherwise.
    if (root.querySelector('[data-cpi-modal]')) return;
    var btn = root.querySelector('[data-cpi-personalise]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url');
      if (url) { window.location.href = url; }
      else { root.dispatchEvent(new CustomEvent('cpi:personalise', { bubbles: true })); }
    });
  }

  CPI.inits.push(initCarousel, initVariants, initSizing, initColours, initQty, initInlineInitials, initAtc, initPersonalise);

  function boot() {
    document.querySelectorAll('[data-cpi-root]:not([data-cpi-ready])').forEach(function (root) {
      root.setAttribute('data-cpi-ready', '1');
      CPI.inits.forEach(function (fn) {
        try { fn(root); } catch (e) { if (window.console) console.error(e); }
      });
    });
  }
  CPI.boot = boot;

  // Run after parsing AND after any deferred feature scripts have registered.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else setTimeout(boot, 0);
  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', boot);
})(window.CPI);
